import SunAccent from "@/components/feature/SunAccent";
import { Link } from "react-router-dom";
import type { Testimonial } from "@/mocks/testimonials";

export default function ReviewsHero({ reviews }: { reviews: Testimonial[] }) {
  const totalPhotos = reviews.reduce((sum, item) => sum + item.photos.length, 0);

  return (
    <section className="relative min-h-[62vh] flex flex-col justify-end overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Fresh%20green%20morning%20portrait%20scene%20of%20a%20group%20of%20happy%20visitors%20walking%20with%20farmers%20through%20a%20green%20rural%20Indian%20field%2C%20soft%20misty%20light%2C%20painterly%20stylized%20earthy%20tones%2C%20storytelling%20mood%2C%20flooded%20with%20golden%20sunrise%20light%2C%20warm%20amber%20sunrays%20and%20soft%20glow%2C%20misty%20atmospheric%20haze%2C%20deep%20rich%20shadows%2C%20vivid%20saturated%20lush%20green%2C%20high%20contrast%20cinematic%20golden%20hour%20richness%2C%20ultra%20detailed&nocache=true&width=1920&height=1080&seq=reviews-hero&orientation=landscape"
          width={1920}
          height={1080}
          alt="Visitors walking with farmers through a green field"
          title="Visitor reviews - Rythugaru agri tourism"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/80"></div>
      </div>

      <div className="relative w-full px-4 md:px-8 pt-28 md:pt-32 pb-12 md:pb-16">
        <nav className="flex items-center gap-2 text-xs md:text-sm text-background-200 mb-6 flex-wrap">
          <Link to="/" className="hover:text-background-50 transition-colors">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-background-50">Visitor Reviews</span>
        </nav>

        <div className="flex items-center gap-3 mb-5">
          <SunAccent circleClassName="w-8 h-8" iconClassName="text-base" /><span className="h-px w-10 bg-accent-400"></span>
          <span className="text-xs font-semibold tracking-[0.28em] uppercase text-accent-300">
            Reviews & Visitor Photo Diaries
          </span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl leading-[1.05] text-background-50 font-semibold max-w-3xl">
          Every Visit Leaves a <span className="italic text-accent-300">Story.</span>
        </h1>
        <p className="mt-6 text-base md:text-lg text-background-100 leading-relaxed max-w-2xl">
          Honest words and real photographs from the families, students, travellers and teams who
          have spent a day on a Rythugaru farm.
        </p>

        <div className="flex flex-wrap gap-x-10 gap-y-5 mt-10">
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">4.9</p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Average Rating</p>
          </div>
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              {reviews.length * 200}+
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Happy Visitors</p>
          </div>
          <div className="border-l-2 border-accent-500/70 pl-4">
            <p className="font-heading text-2xl md:text-3xl text-background-50 font-semibold">
              {totalPhotos}
            </p>
            <p className="text-xs md:text-sm text-background-200 mt-1">Visitor Photos</p>
          </div>
        </div>
      </div>
    </section>
  );
}